export default __webpack_public_path__ + "static/media/ThaiSansNeue-SemiBold.d9220416.ttf";